import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  alert: {
    borderBottom: '1px solid',
    paddingTop: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
    backgroundColor: theme.evPalette.rose[100],
    borderColor: theme.evPalette.rose[900],
    borderRadius: '0px',
    '& ul': {
      paddingLeft: '24px',
      marginTop: '0px',
      color: theme.evPalette.huckleberry[800],
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      marginBottom: '0px',
    },
    '& li': {
      color: theme.evPalette.huckleberry[800],
      cursor: 'pointer',
      width: 'fit-content',
    },
    '& .myev-MuiAlert-message': {
      paddingBottom: '0px',
    },
    '& .myev-MuiAlert-icon': {
      color: theme.evPalette.rose[900],
    },
  },

  mainContainer: {
    gap: '8px',
  },

  title: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19.07px',
    textAlign: 'left',
    color: theme.evPalette.charcoal[900],
  },

  errorHeading: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    textAlign: 'left',
    color: theme.evPalette.charcoal[900],
  },

  button: {
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: '0',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    marginBottom: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  message: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    textAlign: 'left',
    color: theme.evPalette.huckleberry[800],
    textDecoration: 'underline',
  },
}));
